/* eslint-disable max-len */

import React from "react"
import BaseSvgIcon from "./Base"

const Tag = (props) => {
  return (
    <BaseSvgIcon size="25px" {...props}>
      <g fill="none" fillRule="evenodd" stroke="#3d3d36" transform="translate(2 2)">
        <path d="m5.80645161 0 9.19354839 9.19354839-5.80645161 5.80645161-9.19354839-9.19354839v-5.80645161z" />
        <circle cx="3.870968" cy="3.870968" r="1.451613" />
      </g>
    </BaseSvgIcon>
  )
}

export default Tag
